import apiFetch from '@wordpress/api-fetch';

const api = {
	post: ( path, data ) => {
		return apiFetch( {
			path: `/alpha-blocks/v1/${ path }`,
			method: 'POST',
			data,
		} );
	},
	get: ( path ) => {
		return apiFetch( {
			path: `/alpha-blocks/v1/${ path }`,
			method: 'GET',
		} );
	},
};

export default api;
